import { render, staticRenderFns } from "./MenuPage.vue?vue&type=template&id=2431e236&scoped=true&"
import script from "./MenuPage.vue?vue&type=script&lang=ts&"
export * from "./MenuPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2431e236",
  null
  
)

export default component.exports